import React from 'react';
import styleable from 'react-styleable';
import css from './index.scss';
import messages from './messages';
import { displayNewCourses, getNewCoursesTitle } from '../../helpers/utils';

const getUPFCourseTitle = ({ isOptedOut, upfCourseTitle, intl }) => {
    if (upfCourseTitle !== '') {
        return upfCourseTitle;
    }

    if (isOptedOut) {
        return intl.formatMessage(messages.optedOut);
    }

    return intl.formatMessage(messages.noCoursesFound);
};

const RenderClassCourses = ({ yearGroup, courseTitle, conquestCourseTitle, upfCourseTitle, intl, isOptedOut = false }) => {
    const isNewCourseAssigned = conquestCourseTitle !== '';
    const isUPFCourseAssigned = upfCourseTitle !== '';
    const newCourseTitle = getNewCoursesTitle(yearGroup, isNewCourseAssigned, conquestCourseTitle, intl);

    const skillQuestTitle = getUPFCourseTitle({ isOptedOut, upfCourseTitle, intl });
    const course = <div>{intl.formatMessage(messages.activities)}: {courseTitle}</div>;
    const upfCourse = <div className={isUPFCourseAssigned ? 'none' : css.light}><span className={isUPFCourseAssigned ? 'none' : css.bold}>{intl.formatMessage(messages.skillQuests)}:</span> {skillQuestTitle}</div>;

    if (displayNewCourses()) {
        const newCourses = <div className={isNewCourseAssigned ? 'none' : css.light}><span className={isNewCourseAssigned ? 'none' : css.bold}>{intl.formatMessage(messages.newCourses)}:</span> {newCourseTitle}</div>;
        return [course, newCourses, upfCourse];
    }
    return [course, upfCourse];
};

const ClassCourses = styleable(css)(RenderClassCourses);

export default ClassCourses;



// WEBPACK FOOTER //
// ./app/components/class-courses/index.js